export default __webpack_public_path__ + "static/media/MyCardsDetailsBackButton.c7a87646.svg";